// extracted by mini-css-extract-plugin
export default {"headerContainer":"appJcW","headerContainerScrolled":"HLVx0s","titleContainer":"T_oJxn","businessName":"FUVVpg","subtitle":"CmiiI0","userAvatar":"tQLK5h","disconnectButton":"AltGE8"};